import gsap from 'gsap'
import LocomotiveScroll from 'locomotive-scroll'
import { breakpointUp } from './helpers/breakpoints'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { setUpNavigation } from './sections/navigation'
import { setUpFirstBlock} from './sections/first'
import { initializePopups } from './popups'
import { initializeCookies } from './cookies'
import { loadElementLazyImage } from './helpers/lazy-load'

gsap.registerPlugin(ScrollTrigger)

let scrollerElement = '.smooth-scroll'
let nav = $('.js-main-nav')
let scroller = null
let locoScroll = null

if ($(scrollerElement).length) {

  $(window).on('load', function (e) {

    //do not use locomotive scroll in mobile devices
    if(breakpointUp('lg')) {

      scroller = '#scroll'

      locoScroll = new LocomotiveScroll({
        el: document.querySelector(scrollerElement),
        smooth: true,
        tablet: { smooth: true },
        smartphone: { smooth: true },
        lerp: 0.07,
        reloadOnContextChange: true,
      })
      //locoScroll.stop()

      // stop locomotive when hover menu scroll
      if (window.innerHeight <= 650 && window.innerWidth > 1000) {
        nav.mouseover(function () { locoScroll.stop() })
        nav.mouseout(function () { locoScroll.start() })
      }

      // for gsap animations
      locoScroll.on('scroll', () => ScrollTrigger.update())
      ScrollTrigger.scrollerProxy(scroller, {
        scrollTop (value) {
          return arguments.length ? locoScroll.scrollTo(value, 0, 0) : locoScroll.scroll.instance.scroll.y
        },
        getBoundingClientRect () {
          return {
            top: 0,
            left: 0,
            width: window.innerWidth,
            height: window.innerHeight,
          }
        },
        pinType: document.querySelector(scroller).style.transform ? 'transform' : 'fixed',
      })
      ScrollTrigger.addEventListener('refresh', () => locoScroll.update())
      ScrollTrigger.refresh()


      // lazy load for locoscroll, stop video
      let lazyArr = [...document.querySelectorAll('.lazy')]
      let vH = window.innerHeight
      locoScroll.on('scroll', function(e){
        lazyArr.forEach(function(el){
          let elTop = $(el).offset().top
          if (elTop < vH + 200 && elTop > 0) {
            loadElementLazyImage($(el))
            lazyArr.splice( $.inArray(el, lazyArr), 1 );
          }
        })

      })

      // setInterval(function (e){
      //   updateLocoScroll()
      // }, 500)


    } else {
      //$('body, html').addClass('modal-open')
    }



    //--- run functions
    setUpNavigation(locoScroll)
    initializePopups(locoScroll)
    initializeCookies(locoScroll)

  })

}


//Update scroll container height, scroll trigger values
function updateLocoScroll() {
  ScrollTrigger.refresh()
  if(!locoScroll) return false
  locoScroll.update()

}

export function startLocoScroll(){
  locoScroll.start()
}
export function stopLocoScroll(){
  locoScroll.start()
}

$(window).on('load', function (e) {

  setTimeout(function (){
    updateLocoScroll()
  }, 1000)

})

export { updateLocoScroll }



